import {basePath} from "../constants/public-routes";

export default {
  locale: "nl",

  messages: {
    "about": "over deze website",
    "aboutMenu": "Over",
    "aboutThisText": "Over deze tekst",
    "addedtoPrint": "Toegevoegd aan de afdruklijst",
    "addPrint": "Voeg toe aan de afdruklijst",
    "advancedSearch": "Geavanceerd zoeken",
    "advancedSearching": "Meer zoekopties",
    "alsoLookedFor": "Er is ook gezocht voor",
    "annotatedTexts": "Wetteksten",
    "toTheAnnotatedTexts": "naar de wetteksten",
    "annotation": "Annotatie",
    "annotationOf": "Annotatie van",
    "annotations": "Annotaties",
    "annotationsBack": "Naar de annotaties",
    "annotationsOf": "Annotaties van",
    "anyQuestions": "Heb je vragen of opmerkingen? Geef ze door via het contactformulier.",
    "arrest": "Rechtspraak en adviezen",
    "arrests": "Rechtspraak en adviezen",
    "article": "Artikel",
    "articleNumber": "Artikelnummer",
    "author": "Auteur",
    "back": "Terug",
    "backToLastSearch": "Herhaal laatste zoekopdracht",
    "backToPrevious": "Terug naar vorige pagina",
    "belgianSenate": "Belgische Senaat",
    "changeDate": "Datum van de wijziging",
    "clear": "Leegmaken",
    "clearOptions": "Opties wissen",
    "comment": "Toelichting",
    "comments": "Toelichting",
    "contact": "contact",
    "currentLanguage": "Huidige taal",
    "currentVersion": "Geraadpleegde versie",
    "dateAnnounced": "Bekendmaking",
    "dateConfirmed": "Bekrachtiging",
    "dateEffective": "Inwerkingtreding",
    "dateVersion": "Versie",
    "de": "Duits",
    "dia": "SenLex",
    "diaIntro": "<p>De Databank SenLex verzamelt officiële informatie over de Belgische institutionele regelgeving. Deze databank heeft voor u de Grondwet en de belangrijkste institutionele normen gebundeld en per artikel voorzien van relevante fragmenten uit de parlementaire voorbereiding, de rechtspraak van het Grondwettelijk Hof en de adviezen van de Raad van State. U kan de teksten van de institutionele regelgeving raadplegen zoals ze bestonden op het ogenblik van de inwerkingtreding van de Zesde Staatshervorming op 1 juli 2014, met inbegrip van de latere wijzigingen.</p><p><a href='nl/about'>Lees meer</a>.</p>",
    "differentLanguages": "Andere talen",
    "dutch": "Nederlands",
    "effectiveDate": "Datum van inwerkingtreding",
    "element": "Element",
    "Email": "Email",
    "findThis": "Zoek hiernaar",
    "firstArticle": "eerste artikel",
    "foundCategory": "Categorie",
    "foundTag": "trefwoord",
    "fr": "Frans",
    "french": "Frans",
    "from": "uit",
    "german": "Duits",
    "hideAdvancedSearching": "Verberg zoekopties",
    "history": "Wetshistoriek",
    "home": "Home",
    "indexBack": "Naar index",
    "language": "Taal",
    "lastArticle": "laatste artikel",
    "law": "Wet",
    "lawTexts": "Wetteksten",
    "message": "jouw vraag of opmerking",
    "Message": "Boodschap",
    "name": "naam",
    "Name": "Naam",
    "next": "volgende",
    "nl": "Nederlands",
    "noStructureLabel": "[Basiswet]",
    "noVersions": "Er zijn momenteel geen andere versies beschikbaar",
    "onlyOneArticleVersion": "Dit artikel is niet gewijzigd sedert de start van SenLex",
    "noXFound": "Geen {subject} gevonden",
    "or": "of",
    "otherVersions": "Versies",
    "overview": "Overzicht",
    "pref": "Parlementaire voorbereiding",
    "prefs": "Parlementaire voorbereiding",
    "previous": "vorige",
    "previousVersions": "Vorige versies",
    "print": "Afdrukken",
    "printQueue": "Afdruklijst",
    "publication": "Publicatie",
    "query": "Zoekopdracht",
    "quoteTip": "Er wordt gezocht op het exacte woord of de exacte woordcombinatie.<br/>De volgende wild cards kunnen worden gebruikt :<br/>" +
    "- \"?\" : vervangt één letterteken<br/>" +
    "- \"*\" : vervangt 0, één of meerdere lettertekens.",
    "read": "Lees",
    "readOn": "Lees meer",
    "recentChanges": "Recente wijzigingen",
    "ref": "Zie ook",
    "refs": "Zie ook",
    "relevant": "Relevante regelgeving",
    "search": "Zoeken",
    "searchResults": "Resultaten",
    "searchTerm": "Woorden in de tekst",
    "send message": "Bericht versturen",
    "show message": "Bericht tonen",
    "Senlex": "Senlex",
    "showingXofY": "{start, number} - {end, number}",
    "showLess": "toon minder",
    "showMore": "toon meer",
    "simpleSearch": "Eenvoudig zoeken",
    "source": "Bron",
    "stay-informed-latest": "Blijf op de hoogte van de recenste wijzigingen",
    "structure": "Wettekst",
    "subject": "onderwerp",
    "Subject": "Onderwerp",
    "tableOfContents": "Inhoudstafel",
    "tagIndex": "naar het trefwoordenregister",
    "tags": "Trefwoorden",
    "text": "Tekst",
    "tooManyResults": "Er zijn heel veel resultaten gevonden, waardoor mogelijks niet alle resultaten kunnen getoond worden. Gelieve de filters te verstrengen.",
    "type": "Informatiesoort",
    "typeSearch": "Geef hier uw zoekterm in",
    "typeTags": "Geef hier één of meer trefwoorden in",
    "weWillAnswer": "De medewerkers van SenLex proberen zo snel mogelijk een antwoord te sturen. Let op: de Senaat verleent geen juridisch advies.",
    "your email adress": "jouw e-mailadres"
  }
};



/** WEBPACK FOOTER **
 ** ./src/i18n/nl.js
 **/